import { DataTable, TableProvider } from "@xest-ui/data-table";
import MyPaginator from "components/PaginatedTable/MyPaginator";
import { DefaultTableComponents } from "components/PaginatedTable/DefaultTableComponents";
import { useHistory, useLocation } from "react-router-dom";
import updateQueryParams from "components/PaginatedTable/updateQueryParams";
import React from "react";
import getNotifymeUsersLandingPage from "services/getNotifymeUsersLandingPage";

const NotifyMeLandingPageTable = (props) => {
  const history = useHistory();
  const location = useLocation();
  const {
    setShowDeleteDialog,
    setDeleteFunctionToUse,
    setIdToDelete,
    refreshKey,
  } = props;

  const cols = [
    {
      dataIndex: "first_name",
      title: "First Name",
      filterType: {
        dbCol: "notifyme_users_landing_page.first_name",
        type: "string",
      },
      width: 30,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      dataIndex: "last_name",
      title: "Last Name",
      filterType: {
        dbCol: "notifyme_users_landing_page.last_name",
        type: "string",
      },
      width: 30,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      dataIndex: "email",
      title: "Email",
      filterType: {
        dbCol: "notifyme_users_landing_page.email",
        type: "string",
      },
      width: 30,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      dataIndex: "product_name",
      title: "Product Name",
      filterType: {
        dbCol: "notifyme_users.product_name",
        type: "string",
      },
      width: 30,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      dataIndex: "created_at",
      title: "Created At",
      filterType: {
        dbCol: "notifyme_users.created_at",
        type: "string",
      },
      width: 30,
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: "Actions",
      fixed: "right",
      width: 15,
      render(text, record) {
        return (
          <button
            className="btn btn-danger btn-sm"
            style={{ width: "7em", cursor: "pointer" }}
            onClick={(event) => {
              event.stopPropagation();
              setShowDeleteDialog(true);
              setDeleteFunctionToUse("landingPage");
              setIdToDelete(record.notifyme_user_landing_page_id);
            }}
          >
            Delete
            <i className="ion ion-md-trash ml-1" />
          </button>
        );
      },
    },
  ];
  return (
    <TableProvider
      params={{
        apiCallFn: async function (queryParams) {
          const res = await getNotifymeUsersLandingPage({ queryParams });
          return {
            data: res.data,
            total: res.data?.metadata?.total || 0,
          };
        },
        initialPageSize: 10,
        config: {
          tableIdentifier: "get-notifyme-users-landing-page-table",
          updateSearchQueryParams(newParams) {
            updateQueryParams({
              history,
              location,
              newParams,
            });
          },
        },
        initialSortCriteria: "-notifyme_users_landing_page.created_at",
        deps: [refreshKey],
      }}
      components={DefaultTableComponents}
      columns={cols}
    >
      <DataTable pagination={false} />
      <MyPaginator />
    </TableProvider>
  );
};

export default NotifyMeLandingPageTable;
